<template>
  <div class="tags-col">
        <h4>{{ title }}</h4>
        <a-divider></a-divider>
        <div class="tags-holder">
            <template
                v-if="tags.length > 0"
            >
                <a-tag
                    v-for="tag in tags"
                    :key="tag.id"
                    class="tag-colorized"
                >
                    {{ tag.name }}
                </a-tag>
            </template>
            <template
                v-else
            >
                <p>
                    Nem rendelkezik ilyen címkével.
                </p>
            </template>
        </div>
        
        
    </div>
</template>

<script>
export default {
    name: 'FolderDetailsTags',
    props: {
        tags: {
            type: Array,
            default: () => []
        },
        title: {
            type: String,
            default: ''
        }
    }
}
</script>

<style lang="scss" scoped>
    .tag-colorized {
        background-color: $primary-blue;
        color: white;
    }
</style>